const DataConnectorReducer = (state, action) => {
    switch (action.type) {
        case 'set_files':
            return {
                ...state,
                files: action.value,
            }
        case 'set_page':
            return {
                ...state,
                page: action.value,
            }
        case 'set_cancel_upload':
            return {
                ...state,
                cancelUpload: action.value,
            }
        case 'set_step':
            return {
                ...state,
                step: action.value,
            }
        case 'set_uid' :
            return {
                ...state,
                uid: action.value,
            }
        case 'set_connector_uid' :
            return {
                ...state,
                connectorUid: action.value,
            }
        case 'set_data_preview' :
            return {
                ...state,
                dataPreview: action.value,
            }
        case 'set_template' :
            return {
                ...state,
                template: action.value,
            }
        case 'set_add_columns' :
            return {
                ...state,
                addColumns: action.value,
            }
        case 'set_data_mapping' :
            return {
                ...state,
                dataMapping: action.value,
            }
            case 'set_suggestions' :
            return {
                ...state,
                suggestions: action.value,
            }
            case 'set_table' :
            return {
                ...state,
                suggestions: action.table,
            }
        case 'set_order_name' :
            return {
                ...state,
                orderName: action.value,
            }
        case 'set_extra_columns' :
            return {
                ...state,
                extraColumns: action.value,
            }
        default:
            break
    }
}
export default DataConnectorReducer